import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import EducationalSolutionsHeader from "components/Headers/EducationalSolutionsHeader.js";
import MainFooter from "components/Footers/MainFooter.js";

function EducationalSolutions() {
  const [activeTab, setActiveTab] = React.useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  return (
    <>
      <IndexNavbar />
      <EducationalSolutionsHeader />
      <div className="section section-light" id="solutions">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center">
              <h2 className="title">Educational Solutions & Technology</h2>
              <h5 className="description">
                Innovative educational tools and platforms that enhance learning through technology. 
                From AI-powered tutoring to interactive platforms and specialized applications.
              </h5>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="section">
        <Container>
          <div className="nav-tabs-navigation text-center">
            <div className="nav-tabs-wrapper">
              <Nav role="tablist" tabs className="justify-content-center">
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => toggle("1")}
                  >
                    Teachi AI Assistant
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => toggle("2")}
                  >
                    Interactive Platforms
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "3" ? "active" : ""}
                    onClick={() => toggle("3")}
                  >
                    Archery Form Detection
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "4" ? "active" : ""}
                    onClick={() => toggle("4")}
                  >
                    Custom Solutions
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>

          <TabContent className="text-center" activeTab={activeTab}>
            <TabPane tabId="1">
              <Row>
                <Col md="6">
                  <img
                    alt="Teachi AI Assistant"
                    className="img-rounded img-responsive"
                    src={require("assets/img/Teachi.png")}
                    style={{ width: "80%", marginBottom: "20px" }}
                  />
                </Col>
                <Col md="6">
                  <Card>
                    <CardBody>
                      <CardTitle tag="h4">
                        <i className="fa fa-robot"></i> Teachi - AI Educational Assistant
                      </CardTitle>
                      <p>
                        Teachi is our cutting-edge AI assistant that adapts to individual learning styles and provides personalized educational support.
                      </p>
                      <ul className="text-left">
                        <li>Personalized learning paths</li>
                        <li>Real-time feedback and assistance</li>
                        <li>Progress tracking and analytics</li>
                        <li>Multi-subject support</li>
                        <li>Adaptive difficulty adjustment</li>
                      </ul>
                      <Button
                        className="btn-round"
                        color="info"
                        href="/teachi"
                      >
                        Try Teachi Beta
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Card>
                    <CardBody>
                      <h5>Key Features of Teachi:</h5>
                      <Row>
                        <Col md="3">
                          <div className="info text-center">
                            <div className="icon icon-info">
                              <i className="nc-icon nc-bulb-63" />
                            </div>
                            <div className="description">
                              <h6>Adaptive Learning</h6>
                              <p>Adjusts to your learning speed and style</p>
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="info text-center">
                            <div className="icon icon-info">
                              <i className="nc-icon nc-chart-bar-32" />
                            </div>
                            <div className="description">
                              <h6>Progress Tracking</h6>
                              <p>Detailed analytics and insights</p>
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="info text-center">
                            <div className="icon icon-info">
                              <i className="nc-icon nc-chat-33" />
                            </div>
                            <div className="description">
                              <h6>Interactive Support</h6>
                              <p>24/7 availability for questions</p>
                            </div>
                          </div>
                        </Col>
                        <Col md="3">
                          <div className="info text-center">
                            <div className="icon icon-info">
                              <i className="nc-icon nc-settings-gear-65" />
                            </div>
                            <div className="description">
                              <h6>Customizable</h6>
                              <p>Tailored to specific curricula</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            
            <TabPane tabId="2">
              <Row>
                <Col md="12">
                  <Card>
                    <CardBody>
                      <CardTitle tag="h4">
                        <i className="fa fa-gamepad"></i> Interactive Learning Platform
                      </CardTitle>
                      <p>
                        Our interactive learning platform focuses on teaching students real-world engineering in a fun and engaging way. 
                        The goal of the Robotyze lesson curriculum is to teach students how to use STEM as a tool to reach their objectives. 
                        We focus on having students use industry-standard or open-source tools that don't "lock them in" to a platform or one company's hardware.
                      </p>
                      <p className="mb-4">
                        <strong>Our Philosophy:</strong> We teach students how to build, create, and think - not how to use someone's proprietary technology 
                        for a pre-boxed project that they couldn't replace in a different way. If students can't order or build the parts themselves, 
                        then they won't know how to use their experience on a different project!
                      </p>
                      <Row>
                        <Col md="4">
                          <h5>Real-World Skills:</h5>
                          <ul className="text-left">
                            <li>Industry-standard tools and software</li>
                            <li>Open-source hardware and platforms</li>
                            <li>Practical engineering problem-solving</li>
                            <li>Hands-on prototyping and building</li>
                          </ul>
                        </Col>
                        <Col md="4">
                          <h5>Learning Approach:</h5>
                          <ul className="text-left">
                            <li>Project-based learning methodology</li>
                            <li>STEM as a tool for objective achievement</li>
                            <li>Platform-agnostic skill development</li>
                            <li>Creative thinking and innovation</li>
                          </ul>
                        </Col>
                        <Col md="4">
                          <h5>Student Outcomes:</h5>
                          <ul className="text-left">
                            <li>Ability to source and build components</li>
                            <li>Transferable skills across projects</li>
                            <li>Understanding of engineering principles</li>
                            <li>Independence in problem-solving</li>
                          </ul>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Card>
                    <CardBody>
                      <h5>Platform Features:</h5>
                      <Row>
                        <Col md="4">
                          <h6>For Students:</h6>
                          <ul className="text-left">
                            <li>Personalized dashboards</li>
                            <li>Achievement tracking</li>
                            <li>Social learning features</li>
                            <li>Mobile-friendly interface</li>
                          </ul>
                        </Col>
                        <Col md="4">
                          <h6>For Teachers:</h6>
                          <ul className="text-left">
                            <li>Classroom management tools</li>
                            <li>Assessment creation and grading</li>
                            <li>Student progress analytics</li>
                            <li>Curriculum integration</li>
                          </ul>
                        </Col>
                        <Col md="4">
                          <h6>For Administrators:</h6>
                          <ul className="text-left">
                            <li>Institution-wide analytics</li>
                            <li>User management systems</li>
                            <li>Integration with existing systems</li>
                            <li>Custom reporting tools</li>
                          </ul>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            
            <TabPane tabId="3">
              <Row>
                <Col md="6">
                  <Card>
                    <CardBody>
                      <CardTitle tag="h4">
                        <i className="fa fa-bullseye"></i> Form Analysis Technology
                      </CardTitle>
                      <p>
                        Revolutionary computer vision technology that analyzes archery form and provides real-time feedback.
                      </p>
                      <ul className="text-left">
                        <li>Stance and posture alignment detection</li>
                        <li>Bow arm position and stability tracking</li>
                        <li>Draw length and consistency measurement</li>
                        <li>Anchor point accuracy verification</li>
                        <li>Release technique analysis</li>
                        <li>Follow-through motion evaluation</li>
                      </ul>
                      <p>
                        <strong>Technology:</strong> Advanced computer vision algorithms process video in real-time 
                        to identify key form elements and provide instant feedback.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="6">
                  <Card>
                    <CardBody>
                      <CardTitle tag="h4">
                        <i className="fa fa-chart-line"></i> Performance Insights & Coaching
                      </CardTitle>
                      <p>
                        Comprehensive analysis and coaching tools that accelerate learning and skill development.
                      </p>
                      <ul className="text-left">
                        <li>Real-time video analysis with overlays</li>
                        <li>Instant feedback and correction suggestions</li>
                        <li>Progress tracking and trend analysis</li>
                        <li>Comparison with expert form templates</li>
                        <li>Detailed performance reports and metrics</li>
                        <li>Mobile app for remote coaching</li>
                      </ul>
                      <p>
                        <strong>Benefits:</strong> Accelerate learning, reduce bad habits, provide objective feedback, 
                        and enable remote coaching capabilities for students and instructors.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            
            <TabPane tabId="4">
              <Row>
                <Col md="12">
                  <Card>
                    <CardBody>
                      <CardTitle tag="h4">
                        <i className="fa fa-cogs"></i> Custom Educational Solutions
                      </CardTitle>
                      <p className="mb-4">
                        Robotyze brings extensive expertise in multiple technology domains to create custom educational solutions 
                        that meet your specific needs. Our team specializes in connecting the physical and digital worlds through 
                        innovative educational applications.
                      </p>
                      
                      <Row>
                        <Col md="6">
                          <h5>Core Expertise Areas:</h5>
                          <ul className="text-left">
                            <li><strong>IoT Solutions:</strong> Connecting various devices and sensors to the internet for real-world learning</li>
                            <li><strong>Computer Vision:</strong> Advanced image processing and analysis for educational applications</li>
                            <li><strong>Artificial Intelligence:</strong> AI-powered educational tools and adaptive learning systems</li>
                            <li><strong>Web Hosting & Security:</strong> Secure, scalable platforms for educational content delivery</li>
                            <li><strong>Classroom Management:</strong> Digital tools for effective classroom organization and engagement</li>
                            <li><strong>Special Needs Solutions:</strong> Learning games and tools designed for children with Autism and other special needs</li>
                            <li><strong>STEM Expertise:</strong> Comprehensive science, technology, engineering, and mathematics curriculum development</li>
                          </ul>
                        </Col>
                        <Col md="6">
                          <h5>Custom Project Development:</h5>
                          <p>
                            Whether you need specialized educational software, interactive learning experiences, 
                            or technology integration for your curriculum, our team can develop solutions tailored 
                            to your unique requirements.
                          </p>
                          <p className="mb-4">
                            <strong>Ready to explore custom solutions?</strong> Reach out to discuss your specific 
                            educational technology needs and learn how we can help bring your vision to life.
                          </p>
                          <Button
                            className="btn-round"
                            color="info"
                            href="https://book.ms/b/ClassInquiries@robotyze.org"
                            target="_blank"
                          >
                            Discuss Your Custom Project
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
          
          <Row className="text-center">
            <Col md="12">
              <Button
                className="btn-round"
                color="success"
                size="lg"
                href="https://book.ms/b/ClassInquiries@robotyze.org"
                target="_blank"
              >
                Discuss Your Educational Technology Needs
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <MainFooter />
    </>
  );
}

export default EducationalSolutions;
